import { Tag, colors } from 'common-components';
import { PropsWithChildren } from 'react';

const DataLengthTag = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Tag
      type="custom"
      color={colors.gray700}
      bgColor={colors.gray100}
      style={{ padding: '2px 8px', border: 'none', fontSize: 12, lineHeight: '18px', fontWeight: 500, borderRadius: 16 }}
    >
      {children}
    </Tag>
  );
};

export default DataLengthTag;
